var LeafletControlLayersConfig = /** @class */ (function () {
    function LeafletControlLayersConfig() {
        this.baseLayers = {};
        this.overlays = {};
    }
    return LeafletControlLayersConfig;
}());
export { LeafletControlLayersConfig };
//# sourceMappingURL=leaflet-control-layers-config.model.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@asymmetrik/ngx-leaflet/dist/leaflet/layers/control/leaflet-control-layers-config.model.js
// module id = ./node_modules/@asymmetrik/ngx-leaflet/dist/leaflet/layers/control/leaflet-control-layers-config.model.js
// module chunks = vendor